import React from "react";

const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";

const wrapperStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  pointerEvents: "none",
  zIndex: 99999,
  overflow: "hidden",
};

const baseTextStyle = {
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%) rotate(-35deg)",
  fontSize: "clamp(36px, 9vw, 90px)",
  fontWeight: "900",
  fontFamily: "sans-serif",
  letterSpacing: "0.15em",
  color: "rgba(0, 0, 0, 0.11)",
  whiteSpace: "nowrap",
  userSelect: "none",
  textTransform: "uppercase",
};

const positions = ["15%", "50%", "85%"];

function HomologBanner() {
  if (isProduction) return null;
  return (
    <div style={wrapperStyle}>
      {positions.map((top) => (
        <span key={top} style={{ ...baseTextStyle, top }}>
          HOMOLOGAÇÃO
        </span>
      ))}
    </div>
  );
}

export default HomologBanner;
